import { render, staticRenderFns } from "./Act4.vue?vue&type=template&id=ea133fd4&scoped=true"
import script from "./Act4.vue?vue&type=script&lang=js"
export * from "./Act4.vue?vue&type=script&lang=js"
import style0 from "./Act4.vue?vue&type=style&index=0&id=ea133fd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea133fd4",
  null
  
)

export default component.exports